module.exports = __webpack_public_path__ + "img/slide2.fd8ecbc8.png";